import * as fetchApi from '@/config/fetchApi.js'
import * as constants from '@/config/constants.js'
import { queryParam } from '@/config/queryParam.js'

export const getCostumersWithField = ({ data, field }) => fetchApi.post(constants.ENDPOINT_COSTUMERS_CHECK, { customers: data, field })
export const getHotsiteCustomers = (filters) => fetchApi.getFile(constants.ENDPOINT_SIGNUPS + queryParam(filters), 'clientes-hotsite')
